var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('new-text-input',{attrs:{"value":_vm.newName,"name":"new name file","width":230},on:{"change":function($event){return _vm.changeInput('newName', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }